import routerInstance from '@/router/index';
import { computed } from 'vue';
const paths = computed(() =>
  routerInstance
    .getRoutes()
    .map(e => e.path)
    .map(e => e.replaceAll(/(:\w+)/gi, `.*`))
    .map(e => `^${e}$`)
);
/**
 * 정규식으로 패스 체크: 'gi' 플래그는 대소문자 구분 없이 전역 검색
 * @param path
 * @returns {boolean}
 */
const pathsCheck = path => {
  return paths.value.map(e => new RegExp(e, 'gi')).filter(e => e.test(path)).length > 0;
};

export const notRegisteredRoutePath = (to, from, next) => pathsCheck(to.path);
